import { captureException } from '@sentry/nextjs';

export const isExternalUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const isUrlInWhitelist = (url: string, whitelist: string[]) => {
  // Convert wildcard domains in the whitelist to regex patterns
  const regexPatterns = whitelist.map((domain) => {
    // Escape special characters in domain name and convert wildcard * to regex .*
    const regexPattern = domain.replace(/\./g, '\\.').replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
  });

  // Check if the URL matches any of the regex patterns
  const urlDomain = new URL(url).hostname.toLowerCase();
  return regexPatterns.some((pattern) => pattern.test(urlDomain));
};

export const processUrlParams = (url: string) => {
  let parsedUrl = url;
  const isExternal = isExternalUrl(url);
  if (isExternal) {
    if (process.env.REDIRECT_WHITELIST_DOMAINS) {
      const isInWhitelist = isUrlInWhitelist(url, process.env.REDIRECT_WHITELIST_DOMAINS.split(','));
      if (!isInWhitelist) {
        captureException(`Error: search param includes a malicious site: ${url}`);
        parsedUrl = '/';
      }
    }
  }
  return parsedUrl;
};
